module.exports = __webpack_public_path__ + "img/4.3a6dde4d.jpg";